<template>
    <template-base
        title          = "Signatur"
        :items         = "signatures"
        :variables     = "variables"
        :settings-admin = "isSettingsAdmin"
        :header-height = "355"
        @save          = "onSave"
        ref            = "base"
    >
        <template v-slot:ident="data" >
            <v-row class="no-frame mt-0">
                <v-col class="no-frame col-12">
                    <f-read-only-field
                        v-if   = "data.item.standard"
                        label  = "Name"
                        :value = "data.item.name"
                        style  = "margin-top: 5px"
                    />
                    <v-text-field
                        v-if="!data.item.standard"
                        label          = "Name"
                        v-model        = "data.item.name"
                        autocomplete   = "off"
                        autocorrect    = "off"
                        autocapitalize = "off"
                        spellcheck     = "false"
                        :readonly      = "isSettingsAdmin"
                    />
                </v-col>
            </v-row>
        </template>
    </template-base>
</template>

<script>
import TemplateBase from "@/modules/msd/templates/components/TemplateBase";
import Template     from "@/modules/msd/templates/service/Template";
import FReadOnlyField from "@/modules/core/components/utils/FReadOnlyField";
import Core from "@/modules/core/service/Core";

export default {
    name: "TemplateSignatures",
    components: {
        FReadOnlyField,
        TemplateBase
    },

    props: {
        customer: {
            required: false,
            type    : Number,
            default : function () {
                return 0;
            }
        }
    },

    data: () => ({
        signatures: [],
        variables : []
    }),

    computed: {
        isSettingsAdmin () {
            return Core.security.isSettingsAdmin()  || this.customer !== 0;
        }
    },

    mounted() {
        this.$nextTick(() => {
            this.load();
        });
    },

    methods: {
        load () {
            Template.loadSignature(this.customer, (data) => {
                this.signatures = data;
                this.$refs.base.refresh();
            });

            Template.loadVariable( (data) => {
                this.variables = data;
            });
        },

        onSave (signature) {
            Template.saveSignature(signature, () => {
                Core.message.hint(this, "Signatur wurde gespeichert!")
            })
        }
    }

}
</script>

<style scoped>

</style>